module.exports = __webpack_public_path__ + "static/media/img123_R.b351cfad.jpg";